import MessageActivity from "./MessageActivity";

export default MessageActivity;
